define(function () {
  // German
  return {
    errorLoading: function errorLoading() {
      return 'Die Ergebnisse konnten nicht geladen werden.';
    },
    inputTooLong: function inputTooLong(args) {
      var overChars = args.input.length - args.maximum;
      return 'Bitte ' + overChars + ' Zeichen weniger eingeben';
    },
    inputTooShort: function inputTooShort(args) {
      var remainingChars = args.minimum - args.input.length;
      return 'Bitte ' + remainingChars + ' Zeichen mehr eingeben';
    },
    loadingMore: function loadingMore() {
      return 'Lade mehr Ergebnisse…';
    },
    maximumSelected: function maximumSelected(args) {
      var message = 'Sie können nur ' + args.maximum + ' Element';

      if (args.maximum != 1) {
        message += 'e';
      }

      message += ' auswählen';
      return message;
    },
    noResults: function noResults() {
      return 'Keine Übereinstimmungen gefunden';
    },
    searching: function searching() {
      return 'Suche…';
    },
    removeAllItems: function removeAllItems() {
      return 'Entferne alle Elemente';
    }
  };
});